// 顾客单位管理
import {contractApi} from "@/axios";
//获取客户单位信息
export function getCustomerCompanyPage(params,data){
    return contractApi({
        url:'/customer/page',
        method:'post',
        data:data,
        params:params
    })
}
//获取所有客户单位名称
export function getAllCompanyName(){
    return contractApi({
        url:'/customer/companyName',
        method:'get'
    })
}
//添加客户单位信息
export function addCompany(data){
    return contractApi({
        url:'/customer',
        method:'post',
        data:data
    })
}
//修改客户单位信息
export function editCompany(data){
    return contractApi({
        url:'/customer',
        method:'put',
        data:data
    })
}
//删除客户单位信息
export function deleteCompany(params){
    return contractApi({
        url:'/customer',
        method:'delete',
        params:params
    })
}
//更改客户单位启用状态
export function enabledCompany(params) {
    return contractApi({
        url: '/customer/enabled',
        method: 'put',
        params: params
    })
}